import React from 'react'
import { useTranslation } from 'react-i18next'
import {Carousel, Col, Layout, Row} from 'antd'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'

import {LoadingState} from '@/types'
import {TerminalType} from '@/constants'
import {
    TransactionsCardWithBarChartContainer,
    TransactionSummaryListContainer,
    TTransactionsCardWithBarChartContainerStore,
    UserGuideStoreSymbol
} from '@/components/containers'
import {AverageMetrics} from '@/pages/Overview/components/AverageMetrics'
import {CarouselWidgetItem} from '@/pages/Overview/components/CarouselWidgetItem'
import {getOverviewCarouselItems} from '@/constants/overview-carousel'
import styles from './styles.scss'
import {TUserGuideStore} from '@/components/containers/UserGuideContainer/TUserGuideStore'

export const OverviewTransactionSummaryStoreSymbol = Symbol('OverviewTransactionSummaryStore')
export const OverviewChargedTransactionsCardWithBarChartContainerStoreSymbol = Symbol(
    'OverviewChargedTransactionsCardWithBarChartContainerStore'
)
export const OverviewChargedTransactionsComparisonCardWithBarChartContainerStoreSymbol = Symbol(
    'OverviewChargedTransactionsComparisonCardWithBarChartContainerStore'
)

const OverviewOnlinePaymentsAnalytics: React.FC<{}> = observer(() => {
    const { t } = useTranslation()
    const transactionStore = useInjection<TTransactionsCardWithBarChartContainerStore>(
        OverviewChargedTransactionsCardWithBarChartContainerStoreSymbol
    )
    const {setIsModalVisible} = useInjection<TUserGuideStore>(UserGuideStoreSymbol)
    const carouselItems = getOverviewCarouselItems(t, setIsModalVisible)
    return (
        <>
            <Layout.Content className={styles.body}>
                <Row gutter={[16, 16]}>
                    <Col span={24} xs={24}>
                        <TransactionSummaryListContainer
                            type={TerminalType.ECOM}
                            injectableIdentifier={OverviewTransactionSummaryStoreSymbol}
                        />
                    </Col>
                    <Col span={12} xs={24} sm={24} md={24} lg={12}>
                        <TransactionsCardWithBarChartContainer
                            title={t('Overview.chargedTransactions')}
                            injectableIdentifier={
                                OverviewChargedTransactionsCardWithBarChartContainerStoreSymbol
                            }
                        />
                    </Col>
                    <Col span={12} xs={24} sm={24} md={24} lg={12}>
                        <AverageMetrics
                            isLoading={transactionStore.dataLoadingState === LoadingState.LOADING}
                            transactionValue={transactionStore.transactionValue}
                            dailyValue={transactionStore.dailyValue}
                            transactionsPerDay={transactionStore.transactionsPerDay}
                            currency={transactionStore.currency}
                        />
                    </Col>
                    <Col span={12} xs={24} sm={24} md={24} lg={12}>
                        <TransactionsCardWithBarChartContainer
                            title={t('Overview.chargedTransactionsComparison')}
                            injectableIdentifier={
                                OverviewChargedTransactionsComparisonCardWithBarChartContainerStoreSymbol
                            }
                        />
                    </Col>
                    <Col span={12} xs={24} sm={24} md={24} lg={12}>
                        <Carousel autoplay>
                            {carouselItems.map((item, index) => (
                                <CarouselWidgetItem
                                    key={index}
                                    title={t(item.titleKey)}
                                    subtitle={t(item.subtitleKey)}
                                    description={t(item.descriptionKey)}
                                    linkText={t(item.linkTextKey)}
                                    href={item.href}
                                    onLinkClick={item.onLinkClick}
                                    features={item.features}
                                    backgroundColor={item.backgroundColor}
                                />
                            ))}
                        </Carousel>
                    </Col>
                </Row>
            </Layout.Content>
        </>
    )
})

export default OverviewOnlinePaymentsAnalytics
